import { DtcCommerceMmm as DtcCommerceMmmDashboard } from './DtcCommerceMMM';
import {
  COMMERCE_DASHBOARD_CONFIG,
  DTC_DASHBOARD_CONFIG,
  GEO_DASHBOARD_CONFIG
} from './DtcCommerceMMM/dtc-commerce-mmm-variants';
import { MmmVariantPage } from './MmmVariantPage';
import { RMMM_COMMERCE_CONFIG, RMMM_DTC_CONFIG } from './mmm-variant-constants';

/**
 * RmmmDtc/RmmmCommerce are the tabbed MmmVariantPage (Model Results, FAQ, Scenario Planning,
 * Offline Inputs), filtered to dtc/commerce runs — the "split rMMM" pages at /dtc-mmm and
 * /commerce-mmm. The unfiltered /rmmm page is gone; /rmmm and /mmm redirect here
 * (see LegacyRmmmRedirect).
 *
 * CommerceMmm/DtcCommerceMmm/GeoMmmNew are a separate, newer standalone dashboard (not
 * MmmVariantPage) living at /commerce-mmm_new, /dtc-mmm_new and /geo-mmm_new — differing only
 * by the config they pass, so anything that varies between them belongs in that config
 * rather than in a branch here.
 */
export const RmmmDtc = () => <MmmVariantPage config={RMMM_DTC_CONFIG} />;

export const RmmmCommerce = () => <MmmVariantPage config={RMMM_COMMERCE_CONFIG} />;

export const CommerceMmm = () => <DtcCommerceMmmDashboard config={COMMERCE_DASHBOARD_CONFIG} />;

export const DtcCommerceMmm = () => <DtcCommerceMmmDashboard config={DTC_DASHBOARD_CONFIG} />;

export const GeoMmmNew = () => <DtcCommerceMmmDashboard config={GEO_DASHBOARD_CONFIG} />;
